export function init() {
    const imageThumbItems = document.querySelectorAll('.js-gallery-image-thumb');

    /**
     * Image Gallery
     */ 
    imageThumbItems.forEach(el => {
        el.addEventListener('click', () => {
            const index = el.dataset.index,
                gallery = el.closest('.js-gallery'),
                primaryImageList = gallery.querySelector('.js-gallery-primary-images'),
                imageThumbs = gallery.querySelector('.js-gallery-image-thumbs'),
                activePrimaryImage = primaryImageList.querySelector('.block'),
                activeThumbImage = imageThumbs.querySelector('.outline-sbs-blue-800'),
                newActivePrimaryImage = primaryImageList.querySelector(`li[data-index='${index}']`);
       
            // Remove active classes from thumb
            activeThumbImage.classList.add('outline-transparent');
            activeThumbImage.classList.remove('outline-sbs-blue-800');

            // Add active to classes to clicked thumb
            el.classList.add('outline-sbs-blue-800');
            el.classList.remove('outline-transparent');

            // Remove active classes from primary image
            activePrimaryImage.classList.add('hidden');
            activePrimaryImage.classList.remove('block');

            // Find primary image with same index as thumb and add active classes
            newActivePrimaryImage.classList.add('block');
            newActivePrimaryImage.classList.remove('hidden');
        });
    });
}